const startDayOffset = [
  '0',                               // Start current day, end next day
  '-1',                              // Start previous day, end current day
];

export default startDayOffset;
